/* eslint-disable react/react-in-jsx-scope */
import { Folder, ParcelLocationType } from "@/types/dashboard";
// import { DndContext } from "@dnd-kit/core";
import { Map } from "leaflet";
import { ChevronLeft, ChevronRight, FolderPlus } from "lucide-react";
import React from "react";
import MapLayerSelector from "./MapLayerSelector";
import SelectedCardspanelDroppable from "./SelectedCardspanelDroppable";

interface MapSidebarProps {
  isOpen: boolean;
  projectId: number;
  onToggle: () => void;
  folders: Folder[];
  setFolders: React.Dispatch<React.SetStateAction<Folder[]>>;
  currentFolder: Folder | null;
  onAddFolder: () => void;
  onFolderSelect: (folder: Folder) => void;
  isReadOnly?: boolean;
  currentParcel: ParcelLocationType | null;
  handleChange: (parcel: ParcelLocationType, s?: string) => void;
  handleMove: (coordinates: any) => void;
  data: {
    id: number;
    name: string;
    parcels: ParcelLocationType[];
    locations: ParcelLocationType[];
  }[];
  loading: boolean;
  baseLayers: Record<string, any>;
  map: Map | null;
  removePolygon: (id: string) => void;
  polygonMapRef;
}

export default function MapSidebar({
  isOpen,
  projectId,
  onToggle,
  currentFolder,
  onAddFolder,
  onFolderSelect,
  isReadOnly = false,
  currentParcel,
  handleChange,
  handleMove,
  data,
  loading,
  baseLayers,
  map,
  removePolygon,
  polygonMapRef,
}: MapSidebarProps) {
  return (
    <div
      className={`absolute top-0 h-full left-0 z-[9999] bg-white shadow-md transition-all duration-300 ease-in-out ${
        isOpen ? (isOpen ? "w-[19rem] pt-4 pb-12" : "") : "w-0 p-1"
      }`}
      style={{ height: "100%" }}
    >
      <button
        className="absolute top-1/2 -translate-y-1/2 left-full w-8 h-14 bg-white flex items-center justify-center rounded-r-md"
        onClick={onToggle}
      >
        {isOpen ? <ChevronLeft size={20} /> : <ChevronRight size={20} />}
      </button>
      {isOpen && (
        <>
          {!isReadOnly && (
            <div className="flex items-center gap-2 border-b pb-3 pl-4">
              <button
                title="Ajouter un dossier"
                className="flex items-center gap-2"
                onClick={onAddFolder}
              >
                <FolderPlus /> Ajouter un dossier
              </button>
            </div>
          )}

          {/* <DndContext> */}
          <SelectedCardspanelDroppable
            handleChange={handleChange}
            projectId={projectId}
            currentParcel={currentParcel}
            handleMove={handleMove}
            isReadOnly={isReadOnly}
            data={data}
            loading={loading}
            handleChangeCurrentFolder={onFolderSelect}
            currentFolder={currentFolder}
            removePolygon={removePolygon}
            polygonMapRef={polygonMapRef}
          />
          {/* </DndContext> */}
        </>
      )}
      <div className="absolute left-full bottom-0 ml-4 mb-6">
        <MapLayerSelector baseLayers={baseLayers} map={map} />
      </div>
    </div>
  );
}
